import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import NavigationButtonView from './navigation_button_view';
import makeIsActive from '../selectors';

const NavigationButtonContainer = (props) => {
  const { component } = props;
  const getIsActive = useMemo(makeIsActive, []);
  const active = useSelector((state) => getIsActive(state, { component }));

  return (
    <NavigationButtonView active={active} {...props} />
  );
};

NavigationButtonContainer.propTypes = {
  label: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  click: PropTypes.func.isRequired,
  hasBadge: PropTypes.bool.isRequired,
  hasTooltip: PropTypes.bool.isRequired,
  cta: PropTypes.instanceOf(Object).isRequired,
  layout: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default NavigationButtonContainer;
